import { Button, Flex, tokens, Typography, View } from '@sapphire-react/core';
import { Calculator } from '@sapphire/icons/react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import backgroundImage from '../../../images/background.png';

export const TipsContainer = () => {
  const { t } = useTranslation();

  return (
    <BackgroundWrapper>
      <View width={'100%'} paddingTop={32} paddingBottom={32}>
        <Flex
          justifyContent={'space-between'}
          alignItems={'center'}
          height={'100%'}
          paddingLeft={32}
          paddingRight={32}
          gap={32}
        >
          <View height={'100%'}>
            <Typography.Heading
              level={4}
              UNSAFE_style={{ color: tokens.color.foregroundOnNegative.value }}
              marginBottom={4}
            >
              {t('tips.heading')}
            </Typography.Heading>
            <Typography.Body size={'sm'} UNSAFE_style={{ color: tokens.color.foregroundOnNegative.value }}>
              {t('tips.subHeading')}
            </Typography.Body>
            <Button
              elementType={'a'}
              href={t('tips.link')}
              target={'_blank'}
              marginTop={8}
              data-test-id={'apply-for-loan-commitment'}
              variant={'text'}
              size={'lg'}
              icon={<Calculator />}
              UNSAFE_style={{
                color: tokens.color.foregroundOnNegative.value,
              }}
            >
              {t('tips.button')}
            </Button>
          </View>
        </Flex>
      </View>
    </BackgroundWrapper>
  );
};

const BackgroundWrapper = styled.div`
  position: relative;
  width: 100%;
  overflow: hidden;
  background-image: url(${backgroundImage});
  background-size: cover;
  background-position: center;
  border-radius: ${tokens.size.radiusSm.value};
`;
